<template>
  <a
    :href="link"
    :style="{ width: mode === 'button' ? '100%' : '50%' }"
    class="goods-card-container"
    v-if="visible"
  >
    <div class="goods-all-btn__card" :style="cardStyle" v-if="mode === 'card'">
      <AspectRatio :ratio="ratio">
        <div class="cate__image-wrap">
          <van-image :src="imageUrl" :fit="fit" />
        </div>
      </AspectRatio>
      <div class="goods-all-btn__info">
        <p class="cate__name van-ellipsis" v-if="config.show_title">
          {{ config.goods_category.tag_name }}
        </p>
        <template
          v-if="
            config.show_price || config.show_origin_price || config.show_buy_btn
          "
        >
          <van-button plain round size="small" color="orange"
            >查看全部</van-button
          >
        </template>
      </div>
    </div>
    <van-button
      class="goods-all-btn__button"
      size="large"
      v-if="mode === 'button'"
      >查看全部</van-button
    >
  </a>
</template>

<script>
import AspectRatio from "@/components/AspectRatio";
import GoodsCard from "../mixins/GoodsCard";

export default {
  name: "goods-all-btn",
  components: { AspectRatio },
  props: {
    config: Object
  },
  mixins: [GoodsCard],
  data() {
    return {};
  },
  computed: {
    link() {
      return this.config.more_link_url;
    },
    visible() {
      // 显式开启展示更多按钮与顶部菜单时才展示
      return (
        this.config.show_all_btn === 1 && this.config.tag_menu_direction === 0
      );
    },
    mode() {
      // 大图,列表样式,查看更多应为按钮样式
      // 一行两个,一大两小应为卡片模式
      const style = this.config.goods_list_style;
      if ([0, 2].includes(style)) return "button";
      if ([1, 3].includes(style)) return "card";

      return "unknown";
    },

    imageUrl() {
      return this.config.goods_category.image_url;
    }
  },
  methods: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" rel="stylesheet/less">
.goods-all-btn {
  float: left;
  &__card {
    .cate__image-wrap {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .van-image {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        overflow: hidden;
      }
    }
  }

  &__button {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  &__info {
    padding: 10px 10px 0;
    text-align: center;
    .cate__name {
      color: #606969;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
    }
    button {
      width: 100%;
      margin-bottom: 10px;
    }
  }
}
</style>
